import { Component, OnInit, Output } from '@angular/core';
 
import { EventEmitter } from '@angular/core';
import { Contact } from 'src/app/entity/Contact';
import { ContactService } from 'src/app/service/contact.service';


@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss']
})
export class ContactListComponent implements OnInit {

  contacts: Contact[];
  selectedContacts: Contact[];

  selectedContact: Contact;
  @Output() contactsList = new EventEmitter<Contact[]>();
  cols: any[];
  sub: any;
  errorMessage: string = '';

  constructor(private contactService: ContactService) { }

  ngOnInit() {
    this.cols = [

      { field: 'nom', header: 'NOM' },
      { field: 'titres', header: 'POSITION' },

      { field: 'mail', header: 'E-MAIL' }
    ];

    let userID: Number = JSON.parse(sessionStorage.getItem('staff'))[0].userId;
   // this.contactService.getAllByUser(userID).subscribe(p => this.contacts = p);
    this.selectedContacts=[]



  }

  selectedItems: any[];

  select() {
    this.contactsList.emit(this.selectedContacts);
  }



}